"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = saveOptionalFile;

var _clientAwsS = require("@devsta/client-aws-s3");

var _commonReact = require("@devsta/common-react");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function saveOptionalFile(_x) {
  return _saveOptionalFile.apply(this, arguments);
}

function _saveOptionalFile() {
  _saveOptionalFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var apiClient, file, key, organisationId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apiClient = _ref.apiClient, file = _ref.file, key = _ref.key, organisationId = _ref.organisationId;

            if (file) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", {});

          case 3:
            _context.prev = 3;
            _context.next = 6;
            return (0, _clientAwsS.uploadFile)({
              apiClient: apiClient,
              file: file,
              bucketKey: key,
              organisationId: organisationId
            });

          case 6:
            return _context.abrupt("return", {});

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            (0, _commonReact.notify)({
              type: 'error',
              content: 'There was a problem uploading your file. Please try again.'
            });
            return _context.abrupt("return", {
              error: _context.t0.message
            });

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));
  return _saveOptionalFile.apply(this, arguments);
}